import type { SendMicrosoftEmail } from '@cloudFunctions/types/microsoft/sendMicrosoftEmail';
import type { GenerateMicrosoftAuthUrl } from '@cloudFunctions/types/microsoft/generateMicrosoftAuthUrl';
import type { GetMicrosoftCredentials } from '@cloudFunctions/types/microsoft/getMicrosoftCredentials';
import { invokeBackendRoute } from '@/backend/invoke';

export type {
  SendMicrosoftEmail,
  GenerateMicrosoftAuthUrl,
  GetMicrosoftCredentials,
};

export type MicrosoftCredentials =
  GetMicrosoftCredentials.SuccessPayload['credentials'];

/**
 * Generates a Microsoft OAuth 2.0 authorization URL.
 */
export const generateMicrosoftAuthUrl =
  async (): Promise<GenerateMicrosoftAuthUrl.ResponseBody> =>
    invokeBackendRoute<GenerateMicrosoftAuthUrl.ResponseBody>(
      'generateMicrosoftAuthUrl',
    );

export const getMicrosoftCredentials =
  async (): Promise<GetMicrosoftCredentials.Result> =>
    invokeBackendRoute<GetMicrosoftCredentials.Result>(
      'getMicrosoftCredentials',
    );

export const sendMicrosoftEmail = async (
  requestData: SendMicrosoftEmail.RequestData,
): Promise<SendMicrosoftEmail.Result> =>
  invokeBackendRoute<SendMicrosoftEmail.Result, SendMicrosoftEmail.RequestData>(
    'sendMicrosoftEmail',
    requestData,
  );

export const revokeMicrosoftCredentials = async () =>
  invokeBackendRoute<unknown>('revokeMicrosoftCredentials');
